export class ServiceLocation {
    public Code: number = null;
    public End: string = "";
    public EndTime: string = "";
    public Id: string = "";
    public Start: string = "";
    public StartTime: string = "";
    public FacilityId: string = null;
    public FacilityName: string = null;
    public addressLine1: string = "";
    public addressLine2: string = "";
    public city: string = "";
    public state: string = "";
    public zipCode: string = "";
    public country: string = "";
    public county: string = "";

    public constructor(data?: any) {
        if (data) {
            Object.assign(this, data);
            this.addressLine1 = data.AddressLine1 ?? data.addressLine1 ?? this.addressLine1;
            this.addressLine2 = data.AddressLine2 ?? data.addressLine2 ?? this.addressLine2;
            this.city = data.City ?? data.city ?? this.city;
            this.state = data.State ?? data.state ?? this.state;
            this.zipCode = data.zipCode ?? data.ZipCode ?? this.zipCode;
            this.country = data.country ?? data.Country ?? this.country;
            this.county = data.county ?? data.County ?? this.county;
        }
    }
}
